import { render, staticRenderFns } from "./mobileSapAccount.vue?vue&type=template&id=148770c0&scoped=true&"
import script from "./mobileSapAccount.vue?vue&type=script&lang=js&"
export * from "./mobileSapAccount.vue?vue&type=script&lang=js&"
import style0 from "./mobileSapAccount.vue?vue&type=style&index=0&id=148770c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148770c0",
  null
  
)

export default component.exports